<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-form-group
          :label="$lang.state_group_caption"
          label-for="state_group"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.state_group_caption"
            :rules="$v.state_group_selected.$params"
          />
          <selectFind
            :options="state_group_options"
            v-model="$v.state_group_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.state_group_selected.$dirty
                ? !$v.state_group_selected.$error
                : null
            "
            :loading="state_group_Loading"
            @input="getStateDefine"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.state_group_selected.$error ? 'block' : 'none',
            }"
            id="state_group_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.state_group_caption) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.state_define_caption"
          label-for="state_define"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.state_define_caption"
            :rules="$v.state_define_selected.$params"
          />
          <selectFindMultiple
            :options="state_define_options"
            v-model="$v.state_define_selected.$model"
            label="caption"
            id="id"
            :loading="state_define_Loading"
            :removeItem="removeItemActivity"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.state_define_selected.$error ? 'block' : 'none',
            }"
            id="state_define_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.state_define_caption) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" class="float-right">
        <div slot="footer" class="form-group form-btn">
          <!-- v-if="permissionBtn" -->
          <b-button type="submit" size="md" variant="success" @click="submit">
            <i class="fa fa-check"></i>
            {{ $lang.submitButton }}
          </b-button>
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="cancel"
          >
            <i class="fa fa-ban"></i>
            {{ $lang.cancelButton }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  validations: {
    state_define_selected: {},
    state_group_selected: {},
  },
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      state_group_selected: {},
      state_group_Loading: false,
      state_group_options: [],
      state_define_options: [],
      state_define_selected: [],
      state_define_Loading: false,
    };
  },
  methods: {
    submit() {
      let payload = {
        state_define: this.state_define_selected.map((x) => x.id),
      };
      this.$emit("submit", payload);
    },
    cancel() {
      this.$emit("cancel", false);
    },
    removeItemActivity(item) {},
    async getStateGroup() {
      try {
        this.state_group_Loading = true;
        const url = this.$config.api_url + this.$config.resources.state_group;
        const response = await this.$httpService.get(url);
        let { data } = response.data;
        this.state_group_options = data.map((x) => {
          return {
            text: x.state_group_caption,
            value: x.state_group,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.state_group_Loading = false;
      }
    },
    async getStateDefine(item) {
      try {
        this.state_define_Loading = true;
        const url =
          this.$config.api_url +
          this.$config.resources.state_define +
          `?state_group=${item.value}`;
        const response = await this.$httpService.get(url);
        let { data } = response.data;
        this.state_define_options = data.map((x) => {
          return {
            caption: x.caption,
            id: x.id,
            state_name: x.state_name,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.state_define_Loading = false;
      }
    },
  },
  created() {
    this.getStateGroup();
  },
};
</script>
